import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const OdhadyPracnostiPodil = {
	name: NAME,
	apiProvider,
	router,
};
